import { Injectable } from '@angular/core';
// import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { PropertieUtil } from 'app/util/properties.model';
import { UtilidadesService } from 'app/util/utilidades.service';
// import { ApiResponse } from 'app/util/Response.model';

// import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class AccessMenuService {

  subjectTemp: BehaviorSubject<any>;
  propiedad = PropertieUtil;
  msgInvalidLogin: boolean = false;

  listMenu = [];

  public mostrarModalAccesoRestringido$ = new Subject<any>();

  constructor(
    private _httpClient: HttpClient,
    private _fuseNavigationService: FuseNavigationService,
    private _utilidadesService: UtilidadesService
    // private _router: Router
  ) {
    this.subjectTemp = new BehaviorSubject({});
  }

  // resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
  //   return new Promise((resolve, reject) => {

  //     Promise.all([
  //       this.getListMenuCargo(window.localStorage.getItem('idcontrato') != undefined ? window.localStorage.getItem('idcontrato') : "")
  //     ]).then(
  //       () => {
  //         resolve();
  //       },
  //       reject
  //     );
  //   });
  // }

  /*login(loginPayload): Observable<any> {

    return new Observable(
      (observer) => {
        this._httpClient.post<any>(this.propiedad.val_servidor + 'seguridadws/api/login-token', loginPayload)
          // this._httpClient.post<any>(this.propiedad.val_servidor_login + 'token/login-token', loginPayload)
          .subscribe((response: any) => {
            if (response["Status"] == 200) {
              window.localStorage.setItem('token', response["Token"]);
              this.getListMenuCargo(response["Result"]["idcontrato"]);
              // window.localStorage.setItem('data', JSON.stringify(response));
            }
            observer.next(response["Token"]);
            observer.complete();
          }, error => {
            //console.log("Error " + JSON.stringify(error));
            this.msgInvalidLogin = true;
          })
      }
    );
  }*/

  login(loginPayload): Observable<any> {
    return this._httpClient.post<any>(
      this.propiedad.val_servidor + 'seguridadws/api/login-token', 
      loginPayload
    ).pipe(
      map((response: any) => {
        // Si el login es exitoso (Status 200), guarda el token y carga el menú
        if (response && response["Status"] == 200) {
          window.localStorage.setItem('token', response["Token"]);
          this.getListMenuCargo(response["Result"]["idcontrato"]);
        } else {
          this.msgInvalidLogin = true;
        }
        
        // DEVUELVE TODO EL OBJETO para que el componente decida qué hacer
        return response; 
      })
    );
  }

  generateToken(correo): Observable<any> {
    return this._httpClient.post<any>(
      this.propiedad.val_servidor + 'seguridadws/api/generate-token', 
      correo
    ).pipe(
      map((response: any) => {
        // Si el login es exitoso (Status 200), guarda el token y carga el menú
        if (response && response["Status"] == 200) {
          window.localStorage.setItem('token', response["Token"]);
          this.getListMenuCargo(response["Result"]["idcontrato"]);
        } else {
          this.msgInvalidLogin = true;
        }
        
        // DEVUELVE TODO EL OBJETO para que el componente decida qué hacer
        return response; 
      })
    );
  }

  //LLAMAR MENUS DE ACUERDO AL ID DEL CONTRATO
  getListMenuCargo(idcontrato: any) {

    this._httpClient.get<Object>(this.propiedad.val_servidor + this.propiedad.ws_acceso + 'listrestmenucargoparamet?idcontrato=' + idcontrato,
      this._utilidadesService.getHttpOptionsHeaderWithToken()
    ).subscribe((response: any) => {
      if (response["Status"] == 200) {

        this._fuseNavigationService.removeNavigation();

        this.listMenu = response["Status"] == '200' ? response["Result"] : [];
        //console.log("probando", this.listMenu);

        this.listMenu.forEach(element => {
          this._fuseNavigationService.addNavigationItem(element, 'end');
        });
      }
    })
  }




  // return new Promise((resolve, reject) => {
  //   this._httpClient.get<Object>(this.propiedad.val_servidor + this.propiedad.ws_acceso + 'listrestmenucargoparamet?idcontrato=' + idcontrato)
  //     .subscribe((response: any) => {

  //       if (response["Status"] == 200) {
  //         this.listservice = response["Result"];
  //       } else {
  //         this.listservice = [];
  //       }
  //       // console.log(this.listservice);
  //       this.subjectTemp.next(this.listservice);
  //       resolve(response);
  //     }, reject);
  // });

}